export const KEYCLOAK = {
  REALM: "WhyUz",
  APP_CLIENT_ID: "WhyUzFrontEnd",
  COLLAB_CLIENT_ID: "WhyUzCollab"
};
